import { get } from 'lodash';
import queryString from 'query-string';
import React from 'react';
import {
  Image,
  Platform,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { Button as RNButton, Checkbox as RNCheckbox } from 'react-native-paper';
import { URI_IMAGE_CARD } from '../../../utils/cardPayment';
import { parseText } from '../func';
import { getValueBinding } from '../../shared';
import {
  CARD,
  formatCardRecurring,
  labelStyleUnivaPay,
  STATUS_UNIVAPAY,
} from './constant';
import { Props } from './hook';
import createStyles from './style';

const UnivaPayForm: React.FC<Props> = (props) => {
  const {
    loading,
    isSaveCard,
    isDisableButton,
    card,
    uriImage,
    attributes,
    checkTypeCard,
    handleChange,
    handleSubmit,
    cardNameRef,
    cardNumberRef,
    cursor,
    handleChangeCursor,
    toggleSaveCard,
    submitButtonText,
    onlySaveCard,
    recurring,
    data,
    isLoggedInUser,
  } = props;

  const { width, titleCardName, titleCardNumber, submitButton } = attributes;
  const search = queryString.parse(window?.location?.search);
  const target = search?.target;

  const bindingValue = getValueBinding(props.id, data, props);

  const { enabled: titleCardNameEnabled = true } = titleCardName || {};
  const { enabled: titleCardNumberEnabled = true } = titleCardNumber || {};

  const {
    cardName,
    cardNumber,
    cardExpiration,
    cardCvc,
    text: { status, message },
  } = card;

  const styles = createStyles({
    attrs: attributes,
    width,
    disabledButtonSubmit: isDisableButton,
    isError: status !== STATUS_UNIVAPAY.SUCCESSFUL,
    onlySaveCard,
    recurring,
    isLoggedInUser: isLoggedInUser,
  });

  const {
    lengths,
    code: { name: nameCvc, size: sizeCvc },
  } = checkTypeCard || {};

  const { cursorCardName } = cursor || {};

  const maxLengthCardNumber = Math.max(...lengths);

  if (recurring && !onlySaveCard) {
    return (
      <View style={styles.container}>
        <View style={styles.inputCardContainer}>
          <View style={styles.inputCardImage}>
            <Image
              style={styles.cardImage}
              source={{
                uri:
                  URI_IMAGE_CARD[
                    recurring?.data_card.brand as URI_IMAGE_CARD
                  ] || URI_IMAGE_CARD['default'],
              }}
              resizeMode="cover"
            />
          </View>
          <TouchableOpacity activeOpacity={1} style={styles.inputCardNumber}>
            <View style={[styles.inputCardNumber, styles.disabled]}>
              <TextInput
                placeholder="Card number"
                style={styles.input}
                value={formatCardRecurring(
                  recurring?.data_card,
                  CARD.CARD_NUMBER
                )}
                {...(Platform.OS === 'web'
                  ? { ref: cardNumberRef }
                  : {
                      onChangeText: (text) =>
                        handleChange(text, CARD.CARD_NUMBER),
                    })}
                maxLength={maxLengthCardNumber}
                keyboardType="number-pad"
                autoComplete="cc-number"
                ref={cardNumberRef}
                editable={false}
                selectTextOnFocus={false}
              />
            </View>
          </TouchableOpacity>
        </View>
        {!!status && !!message && <Text style={styles.text}>{message}</Text>}
        <View style={styles.btnCard}>
          <RNButton
            style={[styles.btn, styles.btnSubmit]}
            loading={loading}
            disabled={isDisableButton}
            onPress={handleSubmit}
            children={parseText(submitButtonText).toUpperCase()}
            labelStyle={labelStyleUnivaPay(attributes, isDisableButton, target)}
          />
        </View>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {titleCardNameEnabled && (
        <Text style={styles.titleCardName}>
          {get(bindingValue, 'titleCardName.text')}
        </Text>
      )}
      <TouchableOpacity activeOpacity={1}>
        <View style={styles.inputCardName}>
          <TextInput
            placeholder="Card holder name"
            style={styles.input}
            value={cardName}
            onChangeText={(text) => handleChange(text, CARD.CARD_NAME)}
            maxLength={30}
            autoComplete="name"
            {...(Platform.OS === 'web' && {
              onChange: (e: any) => {
                handleChangeCursor(e.target.selectionStart, CARD.CARD_NAME);
              },
              onFocus: (e: any) => {
                e.target.selectionStart = cursorCardName;
              },
              ref: cardNameRef,
            })}
            // {...(isSaveCard && { editable: false, selectTextOnFocus: false })}
          />
        </View>
      </TouchableOpacity>
      {titleCardNumberEnabled && (
        <Text style={styles.titleCardNumber}>
          {get(bindingValue, 'titleCardNumber.text')}
        </Text>
      )}
      <View style={styles.inputCardContainer}>
        <View style={styles.inputCardImage}>
          <Image
            style={styles.cardImage}
            source={{ uri: uriImage }}
            resizeMode="cover"
          />
        </View>
        <TouchableOpacity activeOpacity={1} style={styles.inputCardNumber}>
          <View style={styles.inputCardNumber}>
            <TextInput
              placeholder="Card number"
              style={styles.input}
              value={cardNumber}
              {...(Platform.OS === 'web'
                ? { ref: cardNumberRef }
                : {
                    onChangeText: (text) =>
                      handleChange(text, CARD.CARD_NUMBER),
                  })}
              maxLength={maxLengthCardNumber}
              keyboardType="number-pad"
              autoComplete="cc-number"
              ref={cardNumberRef}
              // {...(isSaveCard && { editable: false, selectTextOnFocus: false })}
            />
          </View>
        </TouchableOpacity>
        <TouchableOpacity activeOpacity={1}>
          <View style={styles.inputCardExpiration}>
            <TextInput
              placeholder="MM / YY"
              style={styles.input}
              value={cardExpiration}
              onChangeText={(text) => handleChange(text, CARD.CARD_EXPIRATION)}
              maxLength={5}
              keyboardType="number-pad"
              autoComplete="cc-exp"
              // {...(isSaveCard && { editable: false, selectTextOnFocus: false })}
            />
          </View>
        </TouchableOpacity>
        <TouchableOpacity activeOpacity={1}>
          <View style={styles.inputCardCVC}>
            <TextInput
              placeholder={nameCvc}
              style={styles.input}
              value={cardCvc}
              onChangeText={(text) => handleChange(text, CARD.CARD_CVC)}
              maxLength={sizeCvc}
              keyboardType="number-pad"
              autoComplete="cc-csc"
              // {...(isSaveCard && { editable: false, selectTextOnFocus: false })}
            />
          </View>
        </TouchableOpacity>
      </View>
      {!onlySaveCard && (
        <View style={styles.checkboxWrapper}>
          <TouchableOpacity
            activeOpacity={1}
            disabled={loading || !isLoggedInUser}
            onPress={toggleSaveCard}
          >
            <View style={styles.checkboxInner}>
              <RNCheckbox
                status={isSaveCard ? 'checked' : 'unchecked'}
                color={'#4a4a4a'}
              />
              <Text style={styles.labelCheckbox}>{'Save card'}</Text>
            </View>
          </TouchableOpacity>
        </View>
      )}
      {!!status && !!message && <Text style={styles.text}>{message}</Text>}
      <View style={styles.btnCard}>
        <RNButton
          style={[styles.btn, styles.btnSubmit]}
          loading={loading}
          disabled={isDisableButton}
          onPress={handleSubmit}
          children={parseText(submitButtonText).toUpperCase()}
          labelStyle={labelStyleUnivaPay(attributes, isDisableButton, target)}
        />
      </View>
    </View>
  );
};

export default UnivaPayForm;
